module.exports = __webpack_public_path__ + "img/IMG Padaria.c3fea779.jpg";